<template>
    <div class="pd-content section-foot d-flex align-items-center" :class="{'section-foot-full':fullFooter}">
        <div class="container ft-family">
            <div v-if="showIcon" class="row">
                <div class="col text-center mb-4">
                    <span class="pr-3">
                        <a href="https://twitter.com/promeraia" class="a-social" target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                            </svg>
                        </a>
                    </span>
                    <span class="pl-3">
                        <a href="https://www.facebook.com/profile.php?id=100078293725607" class="a-social" target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi-facebook" viewBox="0 0 16 16">
                                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                            </svg>
                        </a>
                    </span>
                </div>
            </div>
            <div v-if="showInfo" class="row text-center mb-2">
                    <div class="col">
                        <small>
                            <a href="https://promeraia.com" target="_blank" class="mr-3 a-font text-nowrap"> About us </a>
                            <a href="https://tech.promeraia.com/ja/privacy" target="_blank" class="mr-3 a-font text-nowrap">Privacy Policy</a>
                            <a href="https://tech.promeraia.com/ja/terms" target="_blank" class="mr-3 a-font text-nowrap">Terms of Service</a>
                        </small>
                    </div>
            </div>
            <div class="row text-center">
                    <div class="col">
                        <small>
                            © Promeraia Corp. All rights reserved.
                        </small>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        showIcon:{
            type:Boolean,
            default:false
        },
        showInfo:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        fullFooter () {
            return this.$route.meta.fullFooter
        }
    }
}

</script>

<style lang="stylus" scoped>
.icon-4
    font-size:3rem
    transition:0.1s
.pd-content 
    padding-top:25px;
    padding-bottom:25px;
.section-foot
    height:70px
    margin-top:-70px
    background:white
.section-foot-full
    height:200px!important
    margin-top:-200px!important
.a-font
    color:black
.a-social
    text-decoration: none!important
.a-font:hover
    text-decoration: none!important
    color:#1e9bf0!important
.ft-family
    font-family:"メイリオ"

/* footerのXアイコン */
.bi-twitter-x 
    color: #222;

.bi-twitter-x:hover 
    color:#616163;

/* footerのfacebookアイコン */
.bi-facebook 
    color: #128aed;

.bi-facebook:hover 
    color:#469bdf;

</style>
